module.exports = "/lucky-balls/img/infobox/info_Box_027.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_027.png
// module id = 1092
// module chunks = 0